import React from 'react';
import ReactDOM from 'react-dom';
import './index.scss';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { Route, Router } from 'react-router-dom'
import './i18n';
import './theme/antd.css';
import './theme/antdCustom.scss';
import { createBrowserHistory } from 'history'
import { createPreserveQueryHistory } from './pages/utils/history';


const history = createPreserveQueryHistory(createBrowserHistory, ['ClientKey'])(null);

ReactDOM.render(
  <Router history={history}>
    <Route path="/" component={App} />
  </Router>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
